/**
 * Site identity — the ONE place the web app reads its name and locales from.
 *
 * The `__…__` tokens are filled in by `node scripts/init-site.mjs` when a new
 * client site is created from the template. Do not hand-edit them before that
 * script has run; afterwards this file is ordinary code.
 */

/** Display name: <title> suffix, og:site_name, wordmark, copyright. */
export const SITE_NAME = 'FS K&T'

/** Content locale served WITHOUT a URL prefix (`/about`). */
export const DEFAULT_LOCALE = 'da' as const

/** Second content locale, served under its prefix (`/en/about`). */
export const SECONDARY_LOCALE = 'en' as const

/**
 * Time zone every date is rendered in. Pinned (rather than the machine's own
 * zone) so the SSR server — which runs in UTC — and the visitor's browser
 * render the same calendar day; otherwise a date near midnight differs between
 * server HTML and hydration (React error #418).
 */
export const SITE_TIME_ZONE = 'Europe/Copenhagen'
